import { ScheduleModel, SchedulePayload } from '@app/reducers/orm/schedule/schedule.model';

/**
 * The endpoint merges the fields it is given onto the stored roster — the drag
 * paths omit `starttime`, `endtime` and `shift_id` and those survive. Fields are
 * still listed explicitly rather than spread, so view-only fields never ride
 * along, and `custom_fields` is resent because every other update path does.
 *
 * `User` is the employee the shift is moving away from: `ScheduleService`
 * derives the conflict/compliance refresh set from `user_id` plus `User`, so
 * omitting it leaves the absent employee's stale time-off conflict behind.
 */
export const toReassignPayload = (schedule: ScheduleModel, employeeId: string): SchedulePayload => ({
  id: schedule.id,
  date: schedule.date,
  department_id: schedule.department_id,
  team_id: schedule.team_id,
  user_id: employeeId,
  User: schedule.user_id,
  break: schedule.break,
  custom_fields: schedule.custom_fields,
});
